import { NgTemplateOutlet } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  TemplateRef,
} from '@angular/core';

import { ButtonModule, IconModule, PopoverDirective } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { Positions } from './models';

@Component({
  imports: [
    IconModule,
    PopoverDirective,
    ButtonModule,
    NgTemplateOutlet,
    TranslateModule,
  ],
  selector: 'iw-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  readonly title = input<string>();
  readonly subtitle = input<string>();
  readonly iconName = input('information-circle');
  readonly customContent = input(false, { transform: booleanAttribute });

  readonly position = input<Positions>('bl');
  readonly withoutIcon = input(false);
  readonly tooltipContent = contentChild<TemplateRef<any>>('tooltipContentTpl');
  readonly maxWidth = input<number | undefined>(undefined);
}
